import React from "react";
import { Redirect, Route } from "react-router-dom";
import { apiService } from "service/ApiService";

const ProtectedRoute = ({ component: Component, path }) => {
  if (apiService.isTokenOk() && window.location.pathname.startsWith("/admin")) {
    return <Route path={path} render={(props) => <Component {...props} />} />;
  }
  return <Redirect to={{ pathname: "/auth/login" }} />;
};

export default ProtectedRoute;
